import {
  Button,
  Card,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { RichTextEditor } from "../../../../matx";
import { UploadImage } from "../../../components";
import { getDataAset } from "../../../redux/actions/AsetInvestasiActions";
import { getHotel } from "../../../redux/actions/HotelActions";
import { addPromosi } from "../../../redux/actions/PromosiActions";
import { getDataPropDev } from "../../../redux/actions/PropertyDevelopmentActions";

const TambahPromosi = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [submit, setSubmit] = useState(false);
  const { data: dataAset } = useSelector(({ asetInvest }) => asetInvest);
  const { data: dataPropDev } = useSelector(({ propertyDev }) => propertyDev);
  const { hotel } = useSelector(({ hotel }) => hotel);
  const [params, setParams] = useState({
    thumbnail: "",
    thumbnail_preview: "",
    title_id: "",
    title_en: "",
    desc_id: "",
    desc_en: "",
    from_period: "",
    to_period: "",
    category: "",
    product_code: "",
  });
  const handleChange = ({ target: { value, name } }) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    addPromosi(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    }).then((res) => {
      if (res.isConfirmed && success) {
        history.goBack();
      }
    });
  };
  const handleChangeFoto = (file, path) => {
    setParams((pref) => ({
      ...pref,
      thumbnail: file,
      thumbnail_preview: path,
    }));
  };
  useEffect(() => {
    dispatch(getDataAset({ paginate: false }));
    dispatch(getDataPropDev({ paginate: false }));
    dispatch(getHotel({ paginate: false }));
  }, [dispatch]);

  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Tambah Promosi</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0 ">
            <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <UploadImage
                    uploadFoto={handleChangeFoto}
                    label="Foto Promo"
                    preview={params?.thumbnail_preview}
                    required={true}
                    noCrop
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 500 x 625",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="title_id"
                    value={params.title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="title_en"
                    value={params.title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="category" className="mb-4">
                    Tipe <span className="text-danger">*</span>
                  </InputLabel>
                  <Select
                    labelId="category"
                    value={params.category}
                    onChange={handleChange}
                    variant="outlined"
                    className="w-full"
                    name="category"
                    displayEmpty
                  >
                    <MenuItem value="" selected disabled>
                      Pilih Tipe
                    </MenuItem>
                    <MenuItem value="development">
                      Property Development
                    </MenuItem>
                    <MenuItem value="asset">Aset & Investasi property</MenuItem>
                    <MenuItem value="hotel">Hotel</MenuItem>
                  </Select>
                </Grid>
                {params.category === "asset" ? (
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="product_code" className="mb-4">
                      Property <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      labelId="product_code"
                      value={params.product_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="product_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected disabled>
                        Pilih Property
                      </MenuItem>
                      {dataAset?.map((item) => (
                        <MenuItem
                          value={item.product_code}
                          key={item.product_code}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                ) : params.category === "development" ? (
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="product_code" className="mb-4">
                      Property <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      labelId="product_code"
                      value={params.product_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="product_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected disabled>
                        Pilih Property
                      </MenuItem>
                      {dataPropDev?.map((item) => (
                        <MenuItem
                          value={item.product_code}
                          key={item.product_code}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                ) : params.category === "hotel" ? (
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="product_code" className="mb-4">
                      Property <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      labelId="product_code"
                      value={params.product_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="product_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected disabled>
                        Pilih Hotel
                      </MenuItem>
                      {hotel?.map((item) => (
                        <MenuItem
                          value={item.product_code}
                          key={item.product_code}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                ) : null}
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="from_period" className="mb-4">
                    Tanggal Mulai
                    <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="from_period"
                    placeholder="Tanggal Mulai"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="date"
                    name="from_period"
                    value={params.from_period || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Tanggal Mulai terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="to_period" className="mb-4">
                    Tanggal Berakhir
                    <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="to_period"
                    placeholder="Tanggal Berakhir"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="date"
                    name="to_period"
                    value={params.to_period || ""}
                    validators={["required"]}
                    errorMessages={[
                      "Masukkan Tanggal Berakhir terlebih dahulu",
                    ]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="desc_id" className="mb-4">
                    Promo Detail [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <RichTextEditor
                    handleContentChange={(content) =>
                      setParams((pref) => ({ ...pref, desc_id: content }))
                    }
                    content={params.desc_id}
                    placeholder="Ketik detail promo disini"
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="desc_en" className="mb-4">
                    Promo Detail [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <RichTextEditor
                    handleContentChange={(content) =>
                      setParams((pref) => ({ ...pref, desc_en: content }))
                    }
                    content={params.desc_en}
                    placeholder="Ketik detail promo disini"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        color="primary"
                        className="text-primary w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                        onClick={() => history.goBack()}
                      >
                        Batal
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ValidatorForm>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default TambahPromosi;
